/* eslint-disable complexity */
/* eslint max-params: ["error", 5] */

import './advance-part-tab.scss';
import React, {Component} from 'react';
import DealerDetailsInfo from './dealer-info-details';
import {FormattedMessage} from 'react-intl';
import LabeledInput from '../../../../../../claim/shared/components/claim-fields/labeled-input';
import LabeledTextArea from '../../../../../../claim/shared/components/claim-fields/labeled-text-area';
import PropTypes from 'prop-types';
import RgaDealerDetails from '../../../../../rga-search-results/state/rga-dealer-details';
import RgaDetails from '../../../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../../../../../shared/components/warranty-loading-indicator';

function onChangeDealerInfoFieldValue(propertyName, props, value) {

    props.actions.updateRgaDealerInfoValues(propertyName, value);

}

function onSave() {

    this.actions.postRgaDealerInfoValues(this.rgaDealerDetails);

}

function onCancel() {

    this.actions.getRgaDealerInfo(this.rgaDetails);

}

class DealerDetails extends Component {

    componentWillMount() {

        this.props.actions.getRgaDealerInfo(this.props.rgaDetails);

    }

    componentWillUnmount() {

        this.props.actions.resetProperties('dealerData');

    }

    render() {

        const {rgaDealerDetails} = this.props;

        return (
            <section className='rga-recalled-form'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='row'>
                    <LabeledTextArea
                        className='dealer-address'
                        isEditable={false}
                        label='Dealer Address'
                        onChange={null}
                        tabIndex='22'
                        value={<DealerDetailsInfo dealer={rgaDealerDetails.rgaDealer}/>}
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-cosignment' : 'part-request'}
                        isEditable={true}
                        label='Supplier Part Number'
                        maxLength={15}
                        onChange={onChangeDealerInfoFieldValue.bind(event, 'supplierPartNumber', this.props)}
                        tabIndex='1'
                        value={rgaDealerDetails.supplierPartNumber === null ? '' : rgaDealerDetails.supplierPartNumber}
                    />
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className='disabled-field-dealer'
                        isEditable={true}
                        label='Dealer Comments'
                        onChange={onChangeDealerInfoFieldValue.bind(event, 'dealerComments', this.props)}
                        tabIndex='23'
                        value={rgaDealerDetails.dealerComments === null ? '' : rgaDealerDetails.dealerComments}
                    />
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-dealer' : 'Text-area'}
                        isEditable={true}
                        label='Notes'
                        onChange={onChangeDealerInfoFieldValue.bind(event, 'rgaNotes', this.props)}
                        tabIndex='24'
                        value={rgaDealerDetails.rgaNotes === null ? '' : rgaDealerDetails.rgaNotes}
                    />
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-dealer' : 'Text-area'}
                        isEditable={true}
                        label='Analysis Results'
                        onChange={onChangeDealerInfoFieldValue.bind(event, 'analysisResult', this.props)}
                        tabIndex='24'
                        value={rgaDealerDetails.analysisResult === null ? '' : rgaDealerDetails.analysisResult}
                    />
                </div>
                <div className='row'>
                    <LabeledTextArea
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-dealer' : 'Text-area'}
                        isEditable={true}
                        label='Supplier Analysis'
                        onChange={onChangeDealerInfoFieldValue.bind(event, 'supplierAnalysis', this.props)}
                        tabIndex='24'
                        value={rgaDealerDetails.supplierAnalysis === null ? '' : rgaDealerDetails.supplierAnalysis}
                    />
                </div>
                <section className='button-group recalled-button-group'>
                    <button
                        className='secondary'
                        onClick={onCancel.bind(this.props)}
                    >
                        <FormattedMessage id='CANCEL'/>
                    </button>
                    <button
                        className='primary'
                        disabled={this.props.security.role === 'RGA_USER'}
                        onClick={onSave.bind(this.props)}
                    >
                        <FormattedMessage id='SAVE'/>
                    </button>
                </section>
            </section>
        );

    }
}

DealerDetails.displayName = 'DealerDetails';
DealerDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaDealerDetails: PropTypes.instanceOf(RgaDealerDetails).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default DealerDetails;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/advance-returned-part-information/recalled-part-tab/components/dealer-details.js